import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../components/auth/AuthLayout";
import { apiRequest, ApiError } from "../api/client";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") ?? "";

  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);

    if (!token) {
      setError("Enlace inválido. Solicita un nuevo correo de recuperación.");
      return;
    }
    if (newPassword.length < 8) {
      setError("La nueva contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("La confirmación no coincide con la nueva contraseña.");
      return;
    }

    setLoading(true);
    try {
      const response = await apiRequest<{ message: string }>("/auth/reset-password", {
        method: "POST",
        body: { token, newPassword },
      });
      setSuccess(response.message || "Contraseña restablecida correctamente.");
      setTimeout(() => navigate("/auth/login"), 1300);
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
          ? err.message
          : "No se pudo restablecer la contraseña";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Nueva contraseña"
      subtitle="Define tu nueva contraseña para volver a acceder a tu cuenta."
      footer={
        <p className="section-subtitle">
          ¿Prefieres volver? <Link to="/auth/login">Ir al login</Link>
        </p>
      }
    >
      <form className="form-grid" onSubmit={handleSubmit} noValidate>
        {error && (
          <div className="empty-state" style={{ borderColor: "rgba(220, 38, 38, 0.4)", color: "#b91c1c" }}>
            {error}
          </div>
        )}
        {success && (
          <div className="empty-state" style={{ borderColor: "rgba(16, 185, 129, 0.3)", color: "#166534", background: "rgba(236,253,245,.9)" }}>
            {success}
          </div>
        )}

        <label style={{ fontWeight: 600, color: "#334155" }}>
          Nueva contraseña
          <input
            className="input"
            type="password"
            placeholder="Mínimo 8 caracteres"
            value={newPassword}
            onChange={event => setNewPassword(event.target.value)}
            required
            autoComplete="new-password"
          />
        </label>

        <label style={{ fontWeight: 600, color: "#334155" }}>
          Repetir nueva contraseña
          <input
            className="input"
            type="password"
            placeholder="Repite la contraseña"
            value={confirmPassword}
            onChange={event => setConfirmPassword(event.target.value)}
            required
            autoComplete="new-password"
          />
        </label>

        <button type="submit" className="btn btn-primary" disabled={loading} style={{ justifyContent: "center" }}>
          {loading ? "Guardando..." : "Guardar nueva contraseña"}
        </button>
      </form>
    </AuthLayout>
  );
}
